var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline-flex items-center rounded-full border font-semibold",staticStyle:{"gap":"3px","padding":"4px 8px","font-size":"11.5px","color":"#f1f1f1"},style:({
    backgroundColor: _vm.backgroundColor,
    borderColor: _vm.borderColor
  })},[_c(_vm.icon,{tag:"component",staticStyle:{"margin-left":"-1px"},attrs:{"size":"15"}}),_c('div',{staticClass:"capitalize",staticStyle:{"line-height":"1.2"}},[_vm._v(" "+_vm._s(_vm.phrase)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }